import React from 'react';

export const dataAssetTable = (handleEdit, handleDelete) => {
    return  [
        {
            title: "Id Asset",
            render: rowData => {
                return <span>{rowData.id_asset}</span>
            }
        },
        {
            title: "Asset Kategori",
            render: rowData => {
                return <span>{rowData.asset_kategori}</span>
            }
        },
        {
            title: "Nama Asset",
            render: rowData => {
                return <span>{rowData.nama_asset}</span>
            }
        },
        {
            title: "Sumber Asset",
            render: rowData => {
                return <span>{rowData.sumber_asset}</span>
            }
        },
        {
            title: "Tanggal Perolehan",
            render: rowData => {
                return <span>{rowData.tgl_perolehan}</span>
            }
        },
        {
            title: "Nilai Perolehan",
            render: rowData => {
                return <span>{rowData.nilai_perolehan}</span>
            }
        },
        {
            title: "Umur Ekonomis",
            render: rowData => {
                return <span>{rowData.umur_ekonomis}</span>
            }
        },
        {
            title: "Persen Penyusutan",
            render: rowData => {
                return <span>{rowData.persen_penyusutan}</span>
            }
        },
        {
            title: "Created At",
            render: rowData => {
                return <span>{rowData.created_at}</span>
            }
        },
        {
            title: "Updated At",
            render: rowData => {
                return <span>{rowData.updated_at}</span>
            }
        },
        {
            title: "Action",
            render: rowData => {
                return (
                    <>
                        <button className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2" onClick={(e) => handleEdit(rowData)}>Edit</button>
                        <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded" onClick={(e) => handleDelete(rowData)}>Delete</button>
                    </>
                )
            }
        }
    ]
}